// disOS profile: who's signed in, and sign out.
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/authStore';
import { usePubBody } from './pubBody';
import './public.css';

export function Profile() {
  usePubBody();
  const nav = useNavigate();
  const user = useAuth((s) => s.user);
  const logout = useAuth((s) => s.logout);
  const [busy, setBusy] = useState(false);

  async function signOut() {
    setBusy(true);
    await logout();
    nav('/', { replace: true });
  }

  const initial = (user?.email ?? '?').charAt(0).toUpperCase();
  return (
    <div className="pub">
      <div className="profwrap">
        <Link className="back" to="/app">
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M11 6l-6 6 6 6" /></svg>
          Back to workspace
        </Link>
        <h1>Your account</h1>
        <p className="sub">Manage how you sign in to disOS.</p>

        <div className="profrow">
          <div className="avatar">{initial}</div>
          <div className="who">
            <div className="lbl">Signed in as</div>
            <div className="val">{user?.email ?? '—'}</div>
          </div>
        </div>

        <div className="profrow actions">
          <div className="who">
            <div className="lbl">Session</div>
            <div className="val">Sign out of this browser</div>
          </div>
          <button className="btn danger" type="button" onClick={signOut} disabled={busy}>{busy ? 'Signing out…' : 'Sign out'}</button>
        </div>
      </div>
    </div>
  );
}
